/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FaceAHappyIcon16Light } from './FaceAHappyIcon16Light';
import { FaceAHappyIcon16Regular } from './FaceAHappyIcon16Regular';
import { FaceAHappyIcon16Solid } from './FaceAHappyIcon16Solid';
import { FaceAHappyIcon20Light } from './FaceAHappyIcon20Light';
import { FaceAHappyIcon20Regular } from './FaceAHappyIcon20Regular';
import { FaceAHappyIcon20Solid } from './FaceAHappyIcon20Solid';
import { FaceAHappyIcon24Regular } from './FaceAHappyIcon24Regular';
import { FaceAHappyIcon24Solid } from './FaceAHappyIcon24Solid';
import { FaceAHappyIcon32Regular } from './FaceAHappyIcon32Regular';
import { FaceAHappyIcon64Regular } from './FaceAHappyIcon64Regular';
var sizes = {
    16: {
        light: FaceAHappyIcon16Light,
        regular: FaceAHappyIcon16Regular,
        solid: FaceAHappyIcon16Solid,
    },
    20: {
        light: FaceAHappyIcon20Light,
        regular: FaceAHappyIcon20Regular,
        solid: FaceAHappyIcon20Solid,
    },
    24: {
        regular: FaceAHappyIcon24Regular,
        solid: FaceAHappyIcon24Solid,
    },
    32: {
        regular: FaceAHappyIcon32Regular,
    },
    64: {
        regular: FaceAHappyIcon64Regular,
    },
};
export var FaceAHappyIcon = forwardRef('FaceAHappyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
